/* tslint:disable */
/* eslint-disable */
/**
 * Atelier Roles API
 * L\'Atelier des rôles (BO admin) : référentiel des briques (standard verrouillées, personnalisées administrables), profils (ensembles de rôles appliqués à la création des acteurs) et matrice rôles/portails. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateBriqueCommand
 */
export interface UpdateBriqueCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateBriqueCommand
     */
    description?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateBriqueCommand
     */
    portails: Array<string>;
}

/**
 * Check if a given object implements the UpdateBriqueCommand interface.
 */
export function instanceOfUpdateBriqueCommand(value: object): value is UpdateBriqueCommand {
    if (!('portails' in value) || value['portails'] === undefined) return false;
    return true;
}

export function UpdateBriqueCommandFromJSON(json: any): UpdateBriqueCommand {
    return UpdateBriqueCommandFromJSONTyped(json, false);
}

export function UpdateBriqueCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateBriqueCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'] == null ? undefined : json['description'],
        'portails': json['portails'],
    };
}

export function UpdateBriqueCommandToJSON(json: any): UpdateBriqueCommand {
    return UpdateBriqueCommandToJSONTyped(json, false);
}

export function UpdateBriqueCommandToJSONTyped(value?: UpdateBriqueCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'description': value['description'],
        'portails': value['portails'],
    };
}

